import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {

    const [user, setUser] = useState(() => {
        const savedUser = sessionStorage.getItem('user');
        return savedUser ? JSON.parse(savedUser) : null;
    });


    const [token, setToken] = useState(() => {
        const savedToken = sessionStorage.getItem('token');
        return savedToken || null;
    });

    const [loginType, setLoginType] = useState(() => {
        return sessionStorage.getItem('loginType') || null;
    });


    const login = (userData, accessToken, type) => {
        sessionStorage.setItem('user', JSON.stringify(userData));
        // sessionStorage.setItem('token', userData.accessToken);
        sessionStorage.setItem('token', accessToken);
        sessionStorage.setItem('loginType', type);
        setUser(userData);
        setToken(accessToken);
        setLoginType(type);
    };


    const logout = () => {
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('loginType');
        setUser(null);
        setToken(null);
        setLoginType(null);
    };


    return (
        <AuthContext.Provider value={{  user, token, loginType, login, logout  }}>
            {children}
        </AuthContext.Provider>
    );
};